
import * as actions from "../actions"
import * as vega from "vega"

export function getVegaSpec(file, local) {
  return async function (dispatch) {
    let url = file
    if (local) {
      url = `/static/specs/${file}.json`
    }
    return fetch(url)
      .then(response => response.json())
      .then(json => {
        if (json.exception) {
          dispatch({ type: actions.SET_ERROR, error: { message: `${json.exception} in function getVegaSpec`, type: "error", duration: 4000 } })
        } else {
          return json
        }
      })
  }
}

export function sendSignal(view, { signalName, value }) {
  return async function (dispatch) {
    if (view) {
      if (view.getState().signals.hasOwnProperty(signalName)) {
        await view.signal(signalName, value).runAsync()
      }
    }
  }
}

export function getVegaData(view, key, url) {
  return async function (dispatch) {
    return await fetch(url)
      .then(response => response.json())
      .then(json => {
        dispatch(updateVegaData(view, key, json))
        return json
      })
      .catch(function (error) {
        dispatch({ type: actions.SET_ERROR, error: { message: `${error} in function getVegaData`, type: "error" } })
      })
  }
}

export function updateVegaData(view, key, data) {
  return async function (dispatch) {
    if (view) {
      await view.remove(key, vega.truthy).runAsync()
      await view.insert(key, data).runAsync()

      // await view.insert(key, data).runAsync()
      // await view.change(key, vega.changeset().remove(vega.truthy)).runAsync();
      // await view.change(key, vega.changeset().insert(data).remove(view.data(key))).runAsync()
      // await view.remove(key, function() { return true }).runAsync()
      return data
    }
  }
}
